/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { TICKET_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useCallback, useState } from 'react';
import { useUpdateTicketProperties } from 'conversations-inbox-lib/tickets/mutations/useUpdateTicketProperties';
import Raven from 'raven-js';
import { getChangeTicketPriority } from '../constants/events';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
const alwaysUndefined = emptyFunction.thatReturns(undefined);
const TicketDropdown = ({
  label,
  property,
  value,
  ticketId,
  disabled,
  ticket
}) => {
  const {
    updateTicketProperties
  } = useUpdateTicketProperties({
    ticketId
  });
  const [ticketUpdateIsLoading, setIsDisabled] = useState(false);
  const [hasError, setHasError] = useState(false);
  const getSavedValue = useCallback(propertyName => {
    if (Object.prototype.hasOwnProperty.call(ticket.defaultProperties, propertyName)) {
      return ticket.defaultProperties[propertyName].value;
    }
    const propertyValue = ticket.properties.find(_ => _.name === propertyName);
    return propertyValue ? propertyValue.value : undefined;
  }, [ticket]);
  const onChange = useCallback(propertyChanges => {
    trackEvent(getChangeTicketPriority(property.name));
    const updatedProperties = Object.keys(propertyChanges).map(propertyName => ({
      name: propertyName,
      value: propertyChanges[propertyName] || undefined
    }));
    updateTicketProperties({
      onSuccess: () => {
        setIsDisabled(false);
        setHasError(false);
      },
      onError: error => {
        setIsDisabled(false);
        setHasError(true);
        Raven.captureException(new Error(error));
      },
      properties: updatedProperties
    });
  }, [updateTicketProperties, setIsDisabled, property]);
  return /*#__PURE__*/_jsx(PropertyInputV2, {
    objectTypeId: TICKET_TYPE_ID,
    objectId: `${ticketId}`,
    property: property,
    value: value,
    getDraftValue: alwaysUndefined,
    getSavedValue: getSavedValue,
    disabled: ticketUpdateIsLoading || disabled,
    onChange: onChange,
    className: "p-left-0 p-bottom-0 p-top-1",
    formControlProps: {
      label,
      labelTooltip: disabled ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.ticket-toolbar.ticketOptions.noPermissions"
      }) : undefined,
      error: hasError,
      validationMessage: hasError ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.ticket-toolbar.ticketOptions.errorMessage"
      }) : '',
      verticalSeparation: 'flush',
      className: 'm-x-2',
      labelClassName: 'p-y-0',
      'data-test-id': `ticket-header-${property.name}-dropdown`
    },
    inputProps: {
      buttonUse: 'transparent',
      multiCollapseLimit: 1,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.ticket-toolbar.ticketOptions.default.placeholder"
      }),
      menuWidth: 250
    },
    enableConditionalPropertiesPanel: true,
    enableConditionalPropertyOptions: true
    // This component auto-saves changes immediately without waiting for validation results
    ,
    disableValidation: true,
    showAutoSaveText: true
  });
};
TicketDropdown.displayName = 'TicketDropdown';
export default TicketDropdown;